import { routes } from '@/shared/routes';

import { hideSpinner, showSpinner } from '@/front/spinner';

export const GET = async (url: string) => await fetch_('GET', url);

export const POST = async (url: string, data?: any) => await fetch_('POST', url, data);

export const PATCH = async (url: string, data?: any) => await fetch_('PATCH', url, data);

export const DELETE = async (url: string) => await fetch_('DELETE', url);

const fetch_ = async (method: 'GET' | 'POST' | 'PATCH' | 'DELETE', url: string, data?: any) => {
  showSpinner();

  try {
    const res = await fetch(url, {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      ...(data ? { body: JSON.stringify(data) } : {}),
    });

    hideSpinner();

    if (!(res.ok || res.status === 400)) {
      redirectErrorStatus(res.status);

      throw res.statusText;
    }

    return res;
  } catch (error: any) {
    hideSpinner();
    throw error;
  }
};

export const redirectErrorStatus = (status: number) => {
  if (status >= 401) {
    if (status === 401 || status === 403) {
      window.location.href = routes.unauthorised;
    } else if (status === 404) {
      window.location.href = routes.notFound;
    } else {
      window.location.href = routes.error;
    }
  }
};
